import { render } from "./EditTaskComponent.vue?vue&type=template&id=413a6458&scoped=true"
import script from "./EditTaskComponent.vue?vue&type=script&lang=js"
export * from "./EditTaskComponent.vue?vue&type=script&lang=js"

import "./EditTaskComponent.vue?vue&type=style&index=0&id=413a6458&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413a6458"]])

export default __exports__